{% block sw_extension_card_base_context_menu_actions %}
    {% parent() %}

    <neti-next-order-amount-handler-context-menu-plugin
        v-if="isPluginNetiNextOrderAmountHandler"
        :plugin-name="extension?.name"
    ></neti-next-order-amount-handler-context-menu-plugin>
{% endblock %}